const config = {
    state: {
        app_token: '',
    },

    getters: {
        app_token: (state) => {
            //return () => { return state.app_token};
            return state.app_token;
        }
    },

    mutations: {
        set_app_token(state, app_token) {
            state.app_token = app_token
        }
    },

    actions: {
        set_app_token: ({state, commit, dispatch}, val) => {
            commit('set_app_token', val);
        }
    }
}

export default config;
